import { useState, KeyboardEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { axios, BentoLogo, constants, ErrorBox, PrimaryButton, useAuth } from '@bento-dental/core';
import { OutlinedTextField, PasswordField } from '@bento-dental/core/fields';
import { useQuery } from '@bento-dental/core/hooks';
import { getReturnUrl } from '@bento-dental/core/utilities';

function SignIn() {
  const navigate = useNavigate();
  const queryParams = useQuery();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [signInError, setSignInError] = useState('');

  const onKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleLoginButton();
    }
  };

  const handleLoginButton = () => {
    let isValid = true;

    if (!email) {
      isValid = false;
      setEmailError(constants.VALIDATION.REQUIRED);
    }
    if (!password) {
      isValid = false;
      setPasswordError(constants.VALIDATION.REQUIRED);
    }
    if (!isValid) {
      return;
    }

    setEmailError('');
    setPasswordError('');

    axios
      .post('sign-in/', {
        username: email,
        password,
        request_client: 'admin_portal',
      })
      .then((response) => {
        login(response.data.success);
        navigate(getReturnUrl(queryParams));
      })
      .catch((error) => {
        setSignInError(error.toString());
      });
  };

  return (
    <Box width={500} margin="15% auto">
      <Paper sx={{ padding: 6 }}>
        <BentoLogo portalText="Admin Portal" />
        <Stack component="form" marginTop={4} autoComplete="off" noValidate>
          <OutlinedTextField
            id="username"
            autoComplete="username"
            name="userName"
            label="Username"
            placeholder="Enter Username"
            type="email"
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
              setEmailError('');
              setSignInError('');
            }}
            error={!!emailError}
            helperText={emailError}
            onKeyPress={onKeyPress}
          />
          <PasswordField
            id="current-password"
            autoComplete="current-password"
            name="password"
            label="Password"
            value={password}
            type="password"
            placeholder="Enter Password"
            onChange={(event) => {
              setPassword(event.target.value);
              setPasswordError('');
              setSignInError('');
            }}
            error={!!passwordError}
            helperText={passwordError}
            onKeyDown={onKeyPress}
          />
          <ErrorBox errorMessage={signInError} />
          <PrimaryButton id="sign-in-btn" onClick={handleLoginButton}>
            Sign in
          </PrimaryButton>
        </Stack>
      </Paper>
    </Box>
  );
}

export default SignIn;
